export default __webpack_public_path__ + "svg/calendar/2025/4/mayo.svg?43d69edf";